import { t } from "i18next";
import i18n from "../i18n";

// لتحويل الأرقام حسب اللغة
export const toLocaleDigits = (str, lang) => {
    return String(str).replace(/\d/g, (digit) => {
        return lang === "ar"
            ? "٠١٢٣٤٥٦٧٨٩"[digit]
            : digit; // English uses normal digits
    });
};


export const formatTime = (timeStr) => {
    if (!timeStr || typeof timeStr !== 'string') return '';

    const [hour, minute] = timeStr.split(':');
    const hourNum = parseInt(hour, 10);
    if (isNaN(hourNum)) return timeStr;

    const lang = i18n.language;

    const ampm = hourNum >= 12 ? t("booking.pm") : t("booking.am");

    const formattedHour = hourNum % 12 || 12;

    const formatted = `${formattedHour}:${minute} ${ampm}`;

    return toLocaleDigits(formatted, lang);
};
